module.exports = __webpack_public_path__ + "static/media/3x2 b.c45eaa0c.jpg";